
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class HireIcon extends Vue {
  @Prop() color!: string
}
